import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, FormHelperText, Grid } from "@mui/material";
import SearchableSelect, {
  SelectOption,
} from "app/components/SearchableSelect";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectOrganization } from "store/global/fields/selector";
import { actions } from "store/global/fields/slice";
import { useStyles } from "../styles";
interface TProps {
  value: number;
  xs?: number;
  changeValue: (value: number) => void;
  disabled?: boolean;
  showAll: boolean;
  error?: string;
  activeRequired: boolean;
  isRequired?: boolean;
}
const OrganizationField = (props: TProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const styles = useStyles();
  const List = useSelector(selectOrganization);

  useEffect(() => {
    dispatch(actions.getOrganizationList());
    return () => {};
  }, []);

  const hasError = !!props?.error;
  const loading = List.loading;

  const options: SelectOption[] = List.items.map((item: any) => ({
    label: item.organizationName,
    value: item.id,
    raw: item,
  }));

  return (
    <Grid item xs={props.xs ? props.xs : 2}>
      <label className={styles.label}>
        {t("TIMESLOT.ORGANIZATION_NAME")}
        {props.isRequired && <span style={{ color: "red" }}> *</span>}
        {Number(props.value) > 0 ? (
          <Link
            to={`/organizations/${props.value}/view`}
            target="_blank"
            style={{ textDecoration: "none" }}
            rel="noopener noreferrer"
          >
            <OpenInNewIcon fontSize="small" />
          </Link>
        ) : null}
      </label>
      <SearchableSelect
        options={options}
        value={props.value ?? ""}
        onChange={(val) => props.changeValue(Number(val))}
        disabled={props.disabled}
        loading={loading}
        searchable
        error={hasError}
        className={styles.textEnabled}
        showAllOption={
          props.showAll ? { label: t("COMMON.ALL"), value: 0 } : undefined
        }
      />
      <Box sx={{ display: "flex" }}>
        {hasError && <FormHelperText error>{props?.error}</FormHelperText>}
      </Box>
    </Grid>
  );
};
export default OrganizationField;
